var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_5379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7557 28.5781L24.7815 23.6039C26.137 21.946 26.8035 19.8306 26.643 17.6952C26.4826 15.5597 25.5075 13.5677 23.9195 12.131C22.3315 10.6943 20.252 9.92296 18.1112 9.97649C15.9704 10.03 13.9321 10.9043 12.4178 12.4186C10.9036 13.9328 10.0293 15.9711 9.97576 18.1119C9.92223 20.2527 10.6936 22.3322 12.1303 23.9202C13.5669 25.5082 15.559 26.4833 17.6945 26.6438C19.8299 26.8042 21.9453 26.1377 23.6032 24.7822L28.5773 29.7564C28.7345 29.9082 28.945 29.9922 29.1635 29.9903C29.382 29.9884 29.591 29.9007 29.7455 29.7462C29.9 29.5917 29.9877 29.3827 29.9895 29.1642C29.9914 28.9457 29.9075 28.7352 29.7557 28.5781ZM18.3332 25.0006C17.0146 25.0006 15.7257 24.6096 14.6294 23.877C13.533 23.1445 12.6785 22.1033 12.174 20.8851C11.6694 19.6669 11.5373 18.3265 11.7946 17.0333C12.0518 15.7401 12.6868 14.5522 13.6191 13.6198C14.5515 12.6875 15.7393 12.0526 17.0326 11.7953C18.3258 11.5381 19.6662 11.6701 20.8844 12.1747C22.1025 12.6793 23.1437 13.5338 23.8763 14.6301C24.6088 15.7264 24.9998 17.0153 24.9998 18.3339C24.9978 20.1014 24.2948 21.7959 23.045 23.0457C21.7952 24.2956 20.1007 24.9986 18.3332 25.0006Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_5379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.c4c99f4bf0f0f624f849f3ccc23684b5.svg";
export { ForwardRef as ReactComponent };